export default __webpack_public_path__ + "static/media/cafe-bar.61f33d24.jpg";